import React from 'react';

export const xIcon = () => {
  return (
    <svg width="16.61" height="14.999" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.641 0h2.453L9.709 6.131 16 14.448h-4.937L7.198 9.394l-4.426 5.054H.32l5.705-6.557L0 0h5.06l3.492 4.617L12.642 0Zm-.858 13.009h1.36L4.344 1.386h-1.46l8.898 11.623Z" />
    </svg>
  );
};
